import {
  UitkLayoutGrid,
  UitkLayoutGridItem,
  UitkLayoutGridColumnRow,
  UitkLayoutGridSpan,
} from "uitk-react-layout-grid";
import { UitkText } from "uitk-react-text";
import * as React from "react";
import { ContentProps } from "../../../../typings";
import { decorateEditorialHtml } from "../../../../ContentUtilities";

export const CitiTripleDipIconSectionWithoutAdd = (props: ContentProps) => {
  const flexComponent = props.flexComponent;
  const model = flexComponent && flexComponent.model;
  const items = (model && model.items && model.items.filter((item) => item)) || [];

  if (!model || items.length !== 3) {
    return null;
  }

  const IconColSpan = {
    small: 1 as UitkLayoutGridSpan,
    medium: 2 as UitkLayoutGridSpan,
    large: 2 as UitkLayoutGridSpan,
    extra_large: 2 as UitkLayoutGridSpan,
  };

  const gridColumns = {
    small: 1 as UitkLayoutGridColumnRow,
    medium: 2 as UitkLayoutGridColumnRow,
    large: 2 as UitkLayoutGridColumnRow,
    extra_large: 2 as UitkLayoutGridColumnRow,
  };

  return (
    <UitkLayoutGrid columns={gridColumns} space="six">
      <UitkLayoutGridItem colSpan={IconColSpan} rowSpan={3}>
        <div>
          <div className="uitk-type-center all-b-padding-three">
            <div dangerouslySetInnerHTML={decorateEditorialHtml(items[0].text)} />
          </div>
          <UitkText align="center" size={500} weight="bold">
            <div dangerouslySetInnerHTML={decorateEditorialHtml(items[1].text)} />
          </UitkText>
          <UitkText align="center" size={300}>
            <div dangerouslySetInnerHTML={decorateEditorialHtml(items[2].text)} />
          </UitkText>
        </div>
      </UitkLayoutGridItem>
    </UitkLayoutGrid>
  );
};
export default CitiTripleDipIconSectionWithoutAdd;
